export const styles = {
  radioGroup: {
    flexDirection: 'row',
    marginBottom: 20,
  },
};
